<template>
  <modal
    name="installation-modal"
    :resizable="true"
    :height="'auto'"
    :width="'100%'"
    :scrollable="true"
  >
    <!-- Toast powodzenia -->
    <div v-if="showToast" class="success-toast">
      ✓ Instalacja została zaktualizowana!
    </div>
    <div v-if="showContractorToast" class="success-toast" style="top: 70px;">
      ✓ Zmiany zostały zapisane!
    </div>

    <!-- Nagłówek modalu -->
    <div class="modal-header-custom">
      <div class="header-content">
        <h3 class="modal-title">🔧 {{ installation.contractor.label }}</h3>
        <p class="modal-subtitle">Edycja instalacji</p>
      </div>
      <button class="btn-close-modal" @click="$modal.hide('installation-modal')">
        ✕
      </button>
    </div>

    <!-- Treść modalu -->
    <div class="modal-content-custom">
      <!-- Sekcja danych kontrahenta -->
      <div class="form-section">
        <div class="section-header-with-action">
          <h5 class="section-title">
            <span class="section-icon">👤</span>
            Dane kontrahenta
          </h5>
          <button class="btn-edit-contractor" @click="openContractorModal" title="Edytuj kontrahenta">
            ✏️ Edytuj
          </button>
        </div>

        <div class="info-grid">
          <div class="info-item">
            <span class="info-label">Nazwa:</span>
            <span class="info-value">{{ installation.contractor.label }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">Adres:</span>
            <span class="info-value">{{ installation.contractor.address }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">Numer telefonu:</span>
            <span class="info-value">
              <a :href="`tel:${installation.contractor.phoneNumber}`" class="contact-link">
                {{ installation.contractor.phoneNumber }}
              </a>
            </span>
          </div>
          <div class="info-item">
            <span class="info-label">Email:</span>
            <span class="info-value">
              <a :href="`mailto:${installation.contractor.email}`" class="contact-link">
                {{ installation.contractor.email }}
              </a>
            </span>
          </div>
          <div class="info-item">
            <span class="info-label">NIP:</span>
            <span class="info-value">{{ installation.contractor.nip }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">Osoba Kontaktowa:</span>
            <span class="info-value">{{ installation.contractor.contactPerson }}</span>
          </div>
        </div>
      </div>

      <!-- Sekcja galerii -->
      <div class="form-section">
        <h5 class="section-title">
          <span class="section-icon">📷</span>
          Galeria instalacji
        </h5>

        <div class="gallery-upload">
          <label for="customInputFile" class="upload-btn">
            📷 Dodaj zdjęcie
          </label>
          <input
            id="customInputFile"
            class="upload-input"
            type="file"
            accept="image/*"
            @change="uploadImage"
          />
        </div>

        <div class="gallery-grid" v-if="installation.installation.gallery && installation.installation.gallery.length > 0">
          <a
            v-for="(image, index) in installation.installation.gallery"
            :key="index"
            :href="image"
            target="_blank"
            class="gallery-item"
          >
            <img :src="image" alt="Zdjęcie instalacji" />
          </a>
        </div>
        <div v-else class="no-images">
          Brak zdjęć w galerii
        </div>
      </div>

      <!-- Sekcja szczegółów instalacji -->
      <div class="form-section">
        <h5 class="section-title">
          <span class="section-icon">🛠️</span>
          Szczegóły instalacji
        </h5>

        <div class="form-row">
          <div class="form-group">
            <label class="form-label">Data montażu</label>
            <input
              v-model="installation.installation.date"
              type="date"
              class="form-input"
            />
          </div>

          <div class="form-group">
            <label class="form-label">Data serwisu (wykonany)</label>
            <input
              v-model="installation.installation.service"
              type="date"
              class="form-input"
              @change="updatePlannedService"
            />
          </div>

          <div class="form-group">
            <label class="form-label">Data planowanego serwisu</label>
            <input
              v-model="installation.installation.plannedService"
              type="date"
              class="form-input"
            />
          </div>

          <div class="form-group">
            <label class="form-label">Segregator</label>
            <input
              v-model="installation.installation.binder"
              type="text"
              class="form-input"
              placeholder="Nr segregatora"
            />
          </div>

          <div class="form-group">
            <label class="form-label">Brygada montażowa</label>
            <input
              v-model="installation.installation.squad"
              type="text"
              class="form-input"
              placeholder="Nazwa brygady"
            />
          </div>
        </div>

        <div class="form-group">
          <label class="form-checkbox-wrapper">
            <input
              v-model="installation.installation.underWarranty"
              type="checkbox"
              class="form-checkbox"
            />
            <span class="checkbox-label">
              <span class="checkbox-icon">🛡️</span>
              Urządzenie jest na gwarancji
            </span>
          </label>
        </div>

        <div class="form-group">
          <label class="form-label">Uwagi</label>
          <vue-editor
            v-model="installation.installation.content"
            class="editor"
          ></vue-editor>
        </div>
      </div>
    </div>

    <!-- Fixed footer -->
    <div class="modal-footer-custom">
      <div class="footer-left"></div>
      <div class="footer-center">
        <button class="btn-submit" @click="updateinstallation()">
          <span class="submit-icon">✓</span>
          Zapisz zmiany
        </button>
        <button class="btn-cancel" @click="$modal.hide('installation-modal')">
          Anuluj
        </button>
      </div>
      <div class="footer-right">
        <button class="btn-delete" @click="deleteInstallation(installation)">
          <span class="delete-icon">🗑️</span>
          Usuń instalację
        </button>
      </div>
    </div>

    <!-- Modal kontrahenta -->
    <contractor-modal
      v-if="contractorData"
      @closeModal="closeContractorModal"
      @contractorUpdated="onContractorUpdated"
      :contractor="contractorData"
    ></contractor-modal>
  </modal>
</template>
<script>
import { mapState } from "vuex";
import { VueEditor } from "vue2-editor";
import { fb } from "../firebase";
import ContractorModal from "./ContractorModal";
export default {
  props: ["installation"],
  label: "",

  data() {
    return {
      imageUrl: "",
      consolelog: "test",
      showToast: false,
      showContractorToast: false,
      contractorData: null,
    };
  },
  components: {
    VueEditor,
    ContractorModal,
  },
  computed: {
    ...mapState(["userProfile", "installationUpdated"]),
    installationGallery() {
      if (this.installation.installation.gallery) {
        return this.installation.installation.gallery;
      } else {
        return [];
      }
    },
  },

  methods: {
    openContractorModal() {
      this.contractorData = {
        id: this.installation.contractor.id,
        name: this.installation.contractor.label,
        phoneNumber: this.installation.contractor.phoneNumber,
        email: this.installation.contractor.email,
        address: this.installation.contractor.address,
        nip: this.installation.contractor.nip,
        contactPerson: this.installation.contractor.contactPerson,
        notice: this.installation.contractor.notice || '',
        type: this.installation.contractor.type || 'customer'
      };
      this.$nextTick(() => {
        this.$modal.show("contractor-modal");
      });
    },
    closeContractorModal() {
      this.$modal.hide("contractor-modal");
      this.contractorData = null;
    },
    onContractorUpdated() {
      // Dane kontrahenta zostały zaktualizowane w Firestore
      // Firestore listener automatycznie zaktualizuje dane instalacji w store
      console.log('Contractor updated, data will refresh automatically');
      this.showContractorToast = true;
      setTimeout(() => {
        this.showContractorToast = false;
      }, 2000);
    },
    updatePlannedService() {
      if (this.installation.installation.service) {
        const serviceDate = new Date(this.installation.installation.service);
        serviceDate.setFullYear(serviceDate.getFullYear() + 1);
        const year = serviceDate.getFullYear();
        const month = String(serviceDate.getMonth() + 1).padStart(2, '0');
        const day = String(serviceDate.getDate()).padStart(2, '0');
        this.installation.installation.plannedService = `${year}-${month}-${day}`;
      }
    },
    updateinstallation() {
      // console.log(this.installation);
      // console.log("testowo");
      // console.log(this.installation.service);
      console.log(this.installation.installation.binder);
      if(this.installation.installation.binder == undefined ) {
        this.installation.installation.binder = "";
      }
      console.log(this.installation.installation.binder);
      
      // Build update object, filtering out undefined values
      const updateData = {
        id: this.installation.installation.id,
        address: this.installation.contractor.address || "",
        content: this.installation.installation.content || "",
        email: this.installation.contractor.email || "",
        date: this.installation.installation.date || "",
        service: this.installation.installation.service || "",
        plannedService: this.installation.installation.plannedService || "",
        underWarranty: this.installation.installation.underWarranty || false,
        notice: this.installation.installation.content || "",
        squad: this.installation.installation.squad || "",
        binder: this.installation.installation.binder || "",
        gallery: this.installationGallery || [],
      };
      
      console.log('Sending updateData:', updateData);
      console.log('Notice content:', this.installation.installation.content);
      
      this.$store
        .dispatch("updateInstallation", updateData)
        .then(() => {
          console.log('Installation updated successfully');
          this.showToast = true;
          this.$emit("update-installation");
          setTimeout(() => {
            this.showToast = false;
            this.$emit("closeModal");
          }, 1000);
        })
        .catch((error) => {
          console.error('Error updating installation:', error);
          alert('Błąd przy zapisywaniu instalacji: ' + error.message);
        });
    },

    deleteInstallation(installation) {
      console.log(installation.installation.id);
      if (confirm("Czy jesteś pewien ze chcesz usunąć instalację?")) {
        this.$store.dispatch("deleteInstallation", {
          id: installation.installation.id,
        });
      } else {
        setTimeout(() => {
          this.$emit("closeModal");
        }, 2000);
        console.log("installation Deleted.");
      }
    },
    uuidv4() {
      return "xxxxxxxx-xxxx-xxxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },

    uploadImage(e) {
      let file = e.target.files[0];
      Object.defineProperty(file, "name", {
        writable: true,
        value: this.uuidv4(),
      });
      //   file.name = this.uuidv4()

      fb.storage()
        .ref("installations/" + file.name)
        .put(file)
        .then((uploadTaskSnapshot) => {
          uploadTaskSnapshot.ref.getDownloadURL().then((response) => {
            console.log(response);
            this.installationGallery.push(response);
            //  this.consolelog = downloadURL
          });
        });

      // let uploadTask = storageRef.put(file);
      //     uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
      //       this.task.imageUrl = downloadURL;
      //       this.disabled = 0;
      //       this.showSuccess = true;

      //       setTimeout(() => {
      //         this.showSuccess = false;
      //       }, 2000);
      //     });
    },
  },
};
</script>
<style scoped>
/* --- Toast notification --- */
.success-toast {
  position: fixed;
  top: 20px;
  right: 20px;
  background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
  color: white;
  padding: 16px 24px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(17, 153, 142, 0.3);
  font-weight: 500;
  z-index: 10000;
  animation: slideIn 0.3s ease;
}

@keyframes slideIn {
  from {
    transform: translateX(400px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

/* --- Nagłówek modalu --- */
.modal-header-custom {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 24px 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid #f0f0f0;
}

.header-content {
  flex: 1;
}

.modal-title {
  color: white;
  font-size: 24px;
  font-weight: 700;
  margin: 0 0 4px 0;
}

.modal-subtitle {
  color: rgba(255, 255, 255, 0.9);
  font-size: 14px;
  margin: 0;
}

.btn-close-modal {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: none;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  font-size: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-close-modal:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: rotate(90deg);
}

/* --- Zawartość modalu --- */
.modal-content-custom {
  padding: 32px;
  padding-bottom: 120px;
  max-height: calc(100vh - 300px);
  overflow-y: auto;
}

/* --- Sekcje formularza --- */
.form-section {
  margin-bottom: 32px;
  padding-bottom: 32px;
  border-bottom: 2px solid #f0f0f0;
}

.form-section:last-of-type {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}

.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.section-header-with-action {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.section-header-with-action .section-title {
  margin-bottom: 0;
}

.btn-edit-contractor {
  padding: 8px 16px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 6px rgba(102, 126, 234, 0.3);
}

.btn-edit-contractor:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(102, 126, 234, 0.4);
}

.section-icon {
  font-size: 20px;
}

/* --- Info grid --- */
.info-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.info-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.info-label {
  font-size: 12px;
  font-weight: 600;
  color: #718096;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.info-value {
  font-size: 15px;
  color: #2c3e50;
  font-weight: 500;
}

.contact-link {
  color: #667eea;
  text-decoration: none;
  transition: all 0.3s ease;
}

.contact-link:hover {
  color: #764ba2;
  text-decoration: underline;
}

/* --- Galeria --- */
.gallery-upload {
  margin-bottom: 20px;
}

.upload-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
}

.upload-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}

.upload-input {
  display: none;
}

.gallery-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 12px;
}

.gallery-item {
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  aspect-ratio: 1;
}

.gallery-item:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.gallery-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.no-images {
  padding: 40px;
  text-align: center;
  color: #a0aec0;
  font-style: italic;
  background: #f8f9fa;
  border-radius: 8px;
}

/* --- Form elements --- */
.form-row {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-bottom: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-label {
  font-size: 14px;
  font-weight: 600;
  color: #4a5568;
  margin-bottom: 8px;
}

.form-input {
  padding: 12px 16px;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 15px;
  transition: all 0.3s ease;
}

.form-input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.form-input::placeholder {
  color: #a0aec0;
}

/* --- Checkbox --- */
.form-checkbox-wrapper {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 12px 16px;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  transition: all 0.3s ease;
  background: #f8f9fa;
}

.form-checkbox-wrapper:hover {
  background: #e8edf5;
  border-color: #667eea;
}

.form-checkbox {
  width: 20px;
  height: 20px;
  cursor: pointer;
  margin-right: 12px;
  accent-color: #667eea;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  font-weight: 500;
  color: #2c3e50;
  user-select: none;
}

.checkbox-icon {
  font-size: 18px;
}

/* --- Editor --- */
.editor :deep(.quillWrapper) {
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.editor :deep(.quillWrapper:focus-within) {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.editor :deep(.ql-toolbar) {
  background: #f8f9fa;
  border: none;
  border-bottom: 2px solid #e2e8f0;
}

.editor :deep(.ql-container) {
  border: none;
  min-height: 200px;
  font-size: 15px;
}

/* --- Fixed footer --- */
.modal-footer-custom {
  position: sticky;
  bottom: 0;
  background: white;
  border-top: 2px solid #f0f0f0;
  padding: 20px 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.05);
}

.footer-left,
.footer-center,
.footer-right {
  flex: 1;
  display: flex;
  align-items: center;
}

.footer-center {
  justify-content: center;
  gap: 12px;
}

.footer-right {
  justify-content: flex-end;
}

/* --- Przyciski --- */
.btn-submit {
  padding: 14px 28px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
  display: flex;
  align-items: center;
  gap: 8px;
}

.btn-submit:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(102, 126, 234, 0.4);
}

.submit-icon {
  font-size: 16px;
}

.btn-cancel {
  padding: 12px 24px;
  background: white;
  color: #718096;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-cancel:hover {
  background: #f8f9fa;
  border-color: #cbd5e0;
  color: #4a5568;
}

.btn-delete {
  padding: 12px 24px;
  background: white;
  color: #e53e3e;
  border: 2px solid #fc8181;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
}

.btn-delete:hover {
  background: #fff5f5;
  border-color: #e53e3e;
  color: #c53030;
}

.delete-icon {
  font-size: 16px;
}

/* --- Responsywność --- */
@media (max-width: 768px) {
  .modal-header-custom {
    padding: 16px 20px;
  }

  .modal-title {
    font-size: 20px;
  }

  .modal-content-custom {
    padding: 20px;
    padding-bottom: 140px;
  }

  .info-grid {
    grid-template-columns: 1fr;
  }

  .form-row {
    grid-template-columns: 1fr;
  }

  .gallery-grid {
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  }

  .modal-footer-custom {
    flex-direction: column;
    gap: 12px;
    padding: 16px 20px;
  }

  .footer-left,
  .footer-center,
  .footer-right {
    width: 100%;
    justify-content: center;
  }

  .footer-center {
    flex-direction: column;
  }

  .btn-submit,
  .btn-cancel,
  .btn-delete {
    width: 100%;
    justify-content: center;
  }
}
</style>
